<template>
  <div class="rightModal">
    <InfoBox>
      <div>
        Auto discovery will try to discover;

        <ul class="ul-list-styled pl-3">
          <li>- Compute Members</li>
          <li>- Storage Members</li>
          <li>- Network Members</li>
          <li>- Virtual Machines</li>
          <li>- Virtual Disks</li>
          <li>- Virtual Network Cards</li>
          <li>- Virtual Machines</li>
          <li>- IPs used</li>
        </ul>
      </div>
    </InfoBox>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'

export default {
  name: 'StartAutoDiscovery',
  props: {
    confirmModal: Boolean,
  },
  methods: {
    confirm() {
      ApiService.post(
        `iaas/datacenter-nodes/${this.$route.params.id}/auto-discover`
      )
        .then(({ data }) => {
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
